<template>
  <div :class="styleClasses.card">
    <div :class="styleClasses.card_header">
      <span class="me-2">{{ formatTimestamp(locations[0].time, 'MM/DD HH:mm') }}</span>
      <span>{{ reservation.demandSchedule.demandArea.label }}</span>
    </div>
    <div :class="styleClasses.card_body">
      <div :class="styleClasses.card_body_content" class="pb-2">
        <div :class="styleClasses.reservation">
          <div>
            <div
              class="mb-1"
              v-if="reservation.memo">{{ reservation.memo.memo }}</div>
            <div :class="styleClasses.locations">
              <!-- 乗車地点 -->
              <div
                v-for="(l, i) in locations" :key="i"
                :class="styleClasses.location"
                @click="mapWindowOpen(i)">
                <div>
                  <i class="fa-solid fa-location-dot"/>
                </div>
                <div>
                  <div>{{ formatTimestamp(l.time, 'HH:mm') }}</div>
                  <div>{{ l.address?.replace('日本、', '') }}<br>{{ l.title }}</div>
                  <ApproximateWarning v-if="l.is_approximate === 1"/>
                  <div :class="s.customers">
                    <div
                      :class="s.customer"
                      v-for="(cus, j) in l.customers" :key="j">
                      <div :style="{ backgroundColor: cus.color }"><i :class="cus.type === 'pickup' ? 'fa-solid fa-arrow-up' : 'fa-solid fa-arrow-down'"/></div>
                      <div :style="{ color: cus.color }">{{ cus.user.username }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="styleClasses.status_btns">
            <LargeBtn
              color="blue"
              @click="updateRequest(11)">了解</LargeBtn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  LargeBtn,
  ApproximateWarning,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'request',
  mixins: [cf],
  components: {
    LargeBtn,
    ApproximateWarning,
  },
  props: {
    request: Object,
    styleClasses: Array,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'helper']),
    colors() {
      return this.helper.master.system?.demandMarkerColors || [];
    },
    reservation() {
      return this.request.reservation;
    },
    formatReservation() {
      return this.formatDemandReservation(this.reservation, this.colors);
    },
    locations() {
      return this.formatReservation.locations;
    },
  },
  watch: {},
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    mapWindowOpen(idx) {
      this.$emit('mapWindowOpen', this.locations[idx]);
    },

    updateRequest(flag) {
      this.$emit('updateRequest', { flag, id: this.request.id });
    },
  },
};
</script>

<style lang="scss" module="s">
.customers {
  display: flex;
  > * {
    margin-right: 12px;
  }
}
.customer {
  display: flex;
  align-items: center;
  > :nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    border-radius: 60%;
    color: #ffffff;
    margin-right: 6px;
    > i {
      font-size: 16px !important;
    }
  }
}
</style>
